module.exports = __webpack_public_path__ + "media/wyposazenie/kola@3x-5ff9053c.svg";